import { Dataset } from '../../../../types/types';
import { formatValue } from '../../../../utils/managerUtils';

export const getSubLabelValue = (
  dataset: Dataset,
  currentRow: any,
  firstVisibleColumn: string
) => {
  const labelColumn = dataset.items?.find(
    (item) => item.name === dataset.labelItem
  );
  const resolvedColumn = labelColumn ?? firstVisibleColumn;
  return formatValue(currentRow, resolvedColumn);
};
